import { lazy } from 'react';
import { Routes } from '@/@types/routes.tsx';
import { HOTEL_SETUP_PREFIX_PATH, HOTEL_SETUP_ROUTES } from '@/constants/route.constant.ts';

const hotelSetupRoutes: Routes = [
  {
    key: 'hotelSetup.devices.list',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.DEVICES_LIST}`,
    component: lazy(() => import('@/views/hotel-setup/Devices/Devices')),
    authority: ['SUPERADMIN', 'ADMIN'],
  },
  {
    key: 'hotelSetup.rooms.list',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.ROOMS_LIST}`,
    component: lazy(() => import('@/views/hotel-setup/Rooms/Rooms')),
    authority: ['SUPERADMIN', 'ADMIN'],
  },
  {
    key: 'hotelSetup.rooms.create',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.ROOMS_CREATE}`,
    component: lazy(() => import('@/views/hotel-setup/Rooms/RoomCreate')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Add room',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'hotelSetup.rooms.bulkCreate',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.ROOMS_BULK_CREATE}`,
    component: lazy(() => import('@/views/hotel-setup/Rooms/RoomsBulkCreate')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Bulk create rooms',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'hotelSetup.rooms.edit',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.ROOMS_EDIT}/:id`,
    component: lazy(() => import('@/views/hotel-setup/Rooms/RoomEdit')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Edit room',
        contained: true,
      },
      footer: false,
    },
  },
  {
    key: 'hotelSetup.rooms.announce',
    path: `${HOTEL_SETUP_PREFIX_PATH}/${HOTEL_SETUP_ROUTES.ROOMS_ANNOUNCE}`,
    component: lazy(() => import('@/views/hotel-setup/Rooms/RoomsAnnounce')),
    authority: ['SUPERADMIN', 'ADMIN'],
    meta: {
      header: {
        title: 'Announce',
        contained: true,
      },
      footer: false,
    },
  },
];

export default hotelSetupRoutes;
